import type { StrengthSession, StrengthSessionFormData } from "./types";

export type TrainingTemplateData = Omit<
  StrengthSessionFormData,
  "datum" | "timedGroups" | "poznamka"
> & {
  poznamka?: string | null;
  timedGroups: Array<{ setIndexes: number[]; trvanieSekund: number }>;
};

/** Snapshot values rather than linking a template to the original session. */
export function sessionToTemplateData(
  session: StrengthSession
): TrainingTemplateData {
  return {
    poznamka: session.poznamka ?? undefined,
    serie: session.serie.map(set => ({
      cvikId: set.cvikId,
      hmotnostKg: Number(set.hmotnostKg),
      opakovania: set.opakovania,
    })),
    timedGroups: session.timedGroups.map(group => ({
      trvanieSekund: group.trvanieSekund,
      setIndexes: session.serie.flatMap((set, index) =>
        set.casovaSkupinaId === group.id ? [index] : []
      ),
    })),
  };
}

/** Adapt a snapshot to the existing session editor without retaining real group IDs. */
export function templateDataToSession(
  data: TrainingTemplateData
): StrengthSession {
  return {
    id: 0,
    klientId: 0,
    datum: new Date().toISOString().slice(0, 10),
    poznamka: data.poznamka ?? null,
    createdBy: "trainer",
    serie: data.serie.map((set, index) => ({
      ...set,
      id: index + 1,
      poradie: index,
      cvikNazov: "",
      casovaSkupinaId: (() => {
        const group = data.timedGroups.findIndex(item =>
          item.setIndexes.includes(index)
        );
        return group < 0 ? null : group + 1;
      })(),
    })),
    timedGroups: data.timedGroups.map((group, index) => ({
      id: index + 1,
      treningId: 0,
      cvikId: data.serie[group.setIndexes[0]]?.cvikId ?? 0,
      trvanieSekund: group.trvanieSekund,
    })),
  };
}

export function formToTemplateData(
  form: StrengthSessionFormData
): TrainingTemplateData {
  return {
    poznamka: form.poznamka,
    serie: form.serie,
    timedGroups: form.timedGroups.map(({ setIndexes, trvanieSekund }) => ({
      setIndexes,
      trvanieSekund,
    })),
  };
}
